export default __webpack_public_path__ + "static/soehne-web-kraftig-kursiv-71c978815918cbf37c5afa3b37da4799.woff";